export default "__VITE_ASSET__CcKIUaOm__"